import Button from "@shared/components/ui-kit/form/Button/Button.web";
import { useWizardContext } from "@shared/contexts/WizardContext/WizardContext";
import { useUserSessionAuthState } from "@shared/modules/auth/contexts/useUserSessionAuthState";
import { useTranslation } from "@shared/utils/internationalization";

/**
 * Intended for use only with the checkout step components in the CheckoutSummary
 */
export function ContinueButton() {
  const { currentStep, nextStep } = useWizardContext();
  const { t } = useTranslation("checkout");
  const { isLoggedIn } = useUserSessionAuthState();

  return (
    <Button.Solid
      data-testid="checkout-summary-continue"
      mt="md"
      onClick={async () => {
        nextStep();
      }}
      width="100%"
      fontWeight={700}
      disabled={!currentStep?.isValid}
      display={!isLoggedIn && currentStep?.id === "login" ? "none" : "block"}
    >
      {t("Continue")}
    </Button.Solid>
  );
}
